/* DON'T EDIT THIS FILE: edit original and run build again */ import { UserProfile } from "../../framework/auth-profile/schema.ts";
import { onEmailVerificationViaTokenInputTokenError } from "../../framework/auth-verify-email-token-call/verify-email-token-form-errors.front.tsx";
import { verifyEmailWithTokenCallName } from "../../framework/auth-verify-email-token-call/verify-email-with-token-call-name.ts";
import { VerifyEmailWithTokenCall } from "../../framework/auth-verify-email-token-call/verify-email-with-token-call-signature.ts";
import { verifyMailTokenPrefixLength } from "../../framework/auth-verify-email-typing/verify-email-token-prefix-length.ts";
import { callFirebaseFunction } from "../../framework/firebase/call-firebase-function.ts";
import { TokenLiveField } from "../../framework/live-form-core-types/token/live-field.ts";
import { LiveForm } from "../../framework/live-form-simple/live-form.tsx";
import { LiveFieldset } from "../../framework/live-form/fieldset.ts";
import { LiveRecord } from "../../framework/live-form/live-record.ts";
import { useLiveFormState } from "../../framework/live-form/ui/use-live-form-stte.ts";
import { FormSection } from "../../framework/theme/form-body.tsx";
import { SaveButton } from "../../framework/theme/save-button.tsx";

const fieldset = new LiveFieldset([
  new TokenLiveField({
    field: "token",
    label: "Token de verificación",
    required: true,
    autoComplete: "access-token",
    labelClassName: "mt-5",
    length: verifyMailTokenPrefixLength,
  }),
]);

const handleManualEmailVerifyTokenInput = async (
  tokenCode: string,
  profile: UserProfile
): Promise<void> => {
  try {
    const response = await callFirebaseFunction<VerifyEmailWithTokenCall>(
      verifyEmailWithTokenCallName,
      { tokenCode, uid: profile.uid, isPrefix: true }
    );
    if (!response.ok) {
      await onEmailVerificationViaTokenInputTokenError(response.error);
    }
  } catch (e) {
    console.error("emailVerificationManualTokenError: " + e);
    onEmailVerificationViaTokenInputTokenError(e);
  }
};

const EmailVerificationTokenInputContainer = ({
  onSave,
  children,
}: {
  onSave: () => Promise<void>;
  children?: React.ReactNode;
}): JSX.Element => {
  return (
    <FormSection className="mt-3" includePadding={false}>
      {children}
      <SaveButton
        className="w-100 mt-3 mb-6 btn-md"
        variant="tenant"
        onClick={onSave}
      >
        {"Verificar email"}
      </SaveButton>
    </FormSection>
  );
};

export const ManualTokenInput = ({
  profile,
}: {
  profile: UserProfile;
}): JSX.Element => {
  const state = useLiveFormState({
    fieldset,
    defaultRecordValue: fieldset.createDefaultRecord(),
    defaultShowErrors: false,
    liveData: {},
  });
  const handleSave = async () => {
    handleManualEmailVerifyTokenInput(state.recordValue.token ?? "", profile);
  };
  return (
    <EmailVerificationTokenInputContainer onSave={handleSave}>
      <LiveForm
        liveRecord={
          new LiveRecord(
            fieldset,
            { recordValue: state.recordValue },
            state.showErrors
          )
        }
        saveField={state.saveField}
        onEnterPress={handleSave}
      />
    </EmailVerificationTokenInputContainer>
  );
};
